/** Éléments nécessaires pour décider du rendu de la citation d'une réponse. */
export type ReplyQuoteContext = {
  isStaffView: boolean;
  privateMessage: boolean;
  teamMember: boolean;
  repliedToMessageId: number | null;
  hasParentLoaded: boolean;
};

/**
 * L'historique attendee ne renvoie que les messages épinglés : après un refresh, la réponse privée
 * du modérateur arrive par Ably sans son message d'origine. On affiche alors une citation sans
 * contenu, qui rappelle au participant que la réponse porte sur son propre message.
 */
export function isOrphanPrivateReply(context: ReplyQuoteContext): boolean {
  return (
    !context.isStaffView &&
    context.privateMessage &&
    context.teamMember &&
    context.repliedToMessageId != null &&
    !context.hasParentLoaded
  );
}
